import React, { useMemo, useState, useEffect } from 'react';
import { Input, Tooltip, Tree } from 'antd';
import type { TreeDataNode } from 'antd';
import { useStandard } from '../../hook/useHook';
const { Search } = Input;
const convertTreeData = (treeList) => {
    const loop = (data) =>
        data.map((item) => {
            const { id, name, children, code } = item;
            return {
                name,
                title: <Tooltip title={children && children.length ? name : `${code || ''} ${name}`}>
                    <div
                        style={{
                            width: 200,
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                            overflow: "hidden"
                        }}>
                        {children && children.length ? name : `${code || ''} ${name}`}
                    </div>
                </Tooltip>,
                key: id,
                children: children ? loop(children) : [],
            };
        });
    return loop(treeList);
};
const App = () => {
    const { dictName, getTreeData, setSearchVal } = useStandard()
    const [expandedKeys, setExpandedKeys] = useState<React.Key[]>([]);
    const [autoExpandParent, setAutoExpandParent] = useState(true);
    const [treeData, setTreeData] = useState<TreeDataNode[]>([]);
    const [searchValue, setSearchValue] = useState<any>();
    useEffect(() => {
        if (getTreeData.data) {
            const treeDataConverted = convertTreeData(getTreeData.data);
            setTreeData(treeDataConverted);
            const firstLevelKeys = treeDataConverted.map(node => node.key);
            setExpandedKeys(firstLevelKeys);
        }
    }, [getTreeData.data]);

    const onExpand = (newExpandedKeys: React.Key[]) => {
        setExpandedKeys(newExpandedKeys);
        setAutoExpandParent(false);
    };

    const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { value } = e.target;
        setSearchValue(value)
        getTreeData.run({ searchWord: value })
    };

    const onSelect = (_, e) => {
        const { title, key } = e.node;
        setSearchVal((prev) => ({ ...prev, directoryId: key }));
    };

    useEffect(() => {
        setSearchValue("")
    }, [dictName]);

    return (
        <div>
            <Search
                value={searchValue}
                style={{ marginBottom: 8 }}
                onChange={onChange}
            />
            <Tree
                onExpand={onExpand}
                expandedKeys={expandedKeys}
                autoExpandParent={autoExpandParent}
                treeData={treeData}
                onSelect={onSelect}
            />
        </div>
    );
};

export default App;
